import { render, staticRenderFns } from "./HorasMaisFrequentesCard.vue?vue&type=template&id=0dd01bb4"
import script from "./HorasMaisFrequentesCard.vue?vue&type=script&lang=js"
export * from "./HorasMaisFrequentesCard.vue?vue&type=script&lang=js"
import style0 from "./HorasMaisFrequentesCard.vue?vue&type=style&index=0&id=0dd01bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports